type JwtPayload = {
  exp?: unknown;
};

function decodeTokenPayload(token: string): JwtPayload | null {
  const [, payload] = token.split('.');

  if (!payload) {
    return null;
  }

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = decodeURIComponent(
      atob(base64)
        .split('')
        .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );

    return JSON.parse(decoded) as JwtPayload;
  } catch {
    return null;
  }
}

export function getJwtExpiresAt(token?: string | null): number | null {
  if (!token) {
    return null;
  }

  const payload = decodeTokenPayload(token);

  if (!payload || typeof payload.exp !== 'number') {
    return null;
  }

  return payload.exp * 1000;
}

export function isJwtExpired(token?: string | null): boolean {
  const expiresAt = getJwtExpiresAt(token);

  return expiresAt === null || expiresAt <= Date.now();
}
